__turbopack_context__.v({
  "cell": "ComponentInstance-module-scss-module__3WCf8G__cell",
  "componentAuxiliaryContact": "ComponentInstance-module-scss-module__3WCf8G__componentAuxiliaryContact",
  "componentIcon": "ComponentInstance-module-scss-module__3WCf8G__componentIcon",
  "componentResizeShadow": "ComponentInstance-module-scss-module__3WCf8G__componentResizeShadow",
  "componentSVGIcon": "ComponentInstance-module-scss-module__3WCf8G__componentSVGIcon",
  "componentShadow": "ComponentInstance-module-scss-module__3WCf8G__componentShadow",
  "componentSignOff": "ComponentInstance-module-scss-module__3WCf8G__componentSignOff",
  "componentStatus": "ComponentInstance-module-scss-module__3WCf8G__componentStatus",
  "componentWrapper": "ComponentInstance-module-scss-module__3WCf8G__componentWrapper",
  "leads": "ComponentInstance-module-scss-module__3WCf8G__leads",
  "pulseError": "ComponentInstance-module-scss-module__3WCf8G__pulseError",
  "pulseNotice": "ComponentInstance-module-scss-module__3WCf8G__pulseNotice",
  "pulseSuccess": "ComponentInstance-module-scss-module__3WCf8G__pulseSuccess",
  "subdiagram": "ComponentInstance-module-scss-module__3WCf8G__subdiagram",
});
